import queryString from 'query-string';
export const getQueryParams = (search) => {
    const queryParams = queryString.parse(search);
    return queryParams;
};
